/* angular:styles/component:css;260fdc555606c72ba351c6fa7b400fc2b7e0324ca13d1f1d0f540e47919cf8f9;/src/src/app/shared/components/schedule/form/daily/daily.ts */
.datetime-button::part(native) {
  background-color: var(--ion-color-toolbar-primary);
}
.datetime-button::part(content) {
  padding: 0 !important;
}
.picker-opts {
  --background: none;
}
/*# sourceMappingURL=daily.css.map */
